import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, isRef as _isRef, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["href"];
const _hoisted_2 = ["href"];
const _hoisted_3 = ["href"];
const _hoisted_4 = { key: 0 };
import Customer from "@/model/Customer.model";
import { validationRules } from "@/ValidationRules";
import CreateOrder from "@/model/CreateOrder";
import { PaymentMethod } from "@/model/enum/PaymentMethod";
import { computed, inject, reactive, ref } from "vue";
import { CartServiceSymbol, OrderServiceSymbol } from "@/InjectionSymbols";
import { CreateOrderDto } from "@/dto/CreateOrderDto";
import CheckoutCartRow from "@/components/CheckoutCartRow.vue";
import CartTotals from "@/components/TotalsDisplay.vue";
import { useRouter } from "vue-router";
import { useSettingsStore } from "@/stores/SettingsStore";
import { useI18n } from "vue-i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CheckoutView',
    setup(__props) {
        const { t } = useI18n();
        const settingsStore = useSettingsStore();
        const cartService = inject(CartServiceSymbol);
        const orderService = inject(OrderServiceSymbol);
        const customer = reactive(new Customer());
        const order = reactive(new CreateOrder(customer, cartService.get_cart_items()));
        const router = useRouter();
        let form = ref(null);
        let legalCheckbox = ref(false);
        let orderInFlight = ref(false);
        let paymentFallbackDialog = ref(false);
        const availablePaymentMethods = computed(() => {
            const methods = [];
            if (settingsStore.settings.get('payment_bank_transfer_enabled')?.value === 'true')
                methods.push(PaymentMethod.BANK_TRANSFER);
            if (settingsStore.settings.get('payment_cash_enabled')?.value === 'true')
                methods.push(PaymentMethod.CASH);
            if (settingsStore.settings.get('payment_sumup_enabled')?.value === 'true')
                methods.push(PaymentMethod.SUMUP);
            return methods;
        });
        const canCheckout = computed(() => availablePaymentMethods.value.length > 0 &&
            availablePaymentMethods.value.includes(order.paymentMethod));
        function buyNow() {
            form.value.resetValidation();
            form.value.validate().then((result) => {
                if (result.valid) {
                    orderInFlight.value = true;
                    orderService.placeOrder(new CreateOrderDto(order))
                        .then((response) => {
                        cartService.clearCart();
                        if (response.data.paymentReference) {
                            router.push({
                                name: 'sumupPayment',
                                query: { checkoutId: response.data.paymentReference }
                            });
                            return;
                        }
                        // The backend falls back to bank transfer if the SumUp checkout couldn't be created. The customer is
                        // informed about it first, the dialog then completes the order.
                        if (order.paymentMethod === PaymentMethod.SUMUP && response.data.paymentMethod !== PaymentMethod.SUMUP) {
                            paymentFallbackDialog.value = true;
                            return;
                        }
                        completeOrder();
                    })
                        .finally(() => orderInFlight.value = false);
                }
            });
        }
        function completeOrder() {
            router.push({ name: 'orderReceived' });
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_radio = _resolveComponent("v-radio");
            const _component_v_radio_group = _resolveComponent("v-radio-group");
            const _component_i18n_t = _resolveComponent("i18n-t");
            const _component_v_checkbox = _resolveComponent("v-checkbox");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            const _component_v_form = _resolveComponent("v-form");
            return (_openBlock(), _createBlock(_component_v_form, {
                ref_key: "form",
                ref: form
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_container, { class: "d-flex flex-wrap pa-2" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_container, { class: "d-flex text-h4 justify-center justify-sm-start pa-0" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('checkout.title')), 1)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_container, { class: "v-col-12 d-flex flex-wrap align-content-space-between pa-0" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_container, { class: "v-col-12 v-col-md-6 pr-md-4 pa-0" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_container, { class: "d-flex text-h6 justify-start pa-2" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(t)('checkout.customerData')), 1)
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_divider),
                                            _createVNode(_component_v_container, { class: "d-flex flex-wrap pa-0" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                        class: "v-col-12 compact pt-4",
                                                        modelValue: customer.company,
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((customer.company) = $event)),
                                                        rules: [],
                                                        label: _unref(t)('checkout.company'),
                                                        density: "compact",
                                                        "data-cy": "company"
                                                    }, null, 8, ["modelValue", "label"]),
                                                    _createVNode(_component_v_text_field, {
                                                        class: "v-col-6 compact",
                                                        modelValue: customer.firstname,
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((customer.firstname) = $event)),
                                                        rules: [_unref(validationRules).required],
                                                        label: _unref(t)('checkout.firstname'),
                                                        density: "compact",
                                                        "data-cy": "firstname"
                                                    }, null, 8, ["modelValue", "rules", "label"]),
                                                    _createVNode(_component_v_text_field, {
                                                        class: "v-col-6 compact",
                                                        modelValue: customer.lastname,
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((customer.lastname) = $event)),
                                                        rules: [_unref(validationRules).required],
                                                        label: _unref(t)('checkout.lastname'),
                                                        density: "compact",
                                                        "data-cy": "lastname"
                                                    }, null, 8, ["modelValue", "rules", "label"]),
                                                    _createVNode(_component_v_text_field, {
                                                        class: "v-col-9 compact",
                                                        modelValue: customer.street,
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((customer.street) = $event)),
                                                        rules: [_unref(validationRules).required],
                                                        label: _unref(t)('checkout.street'),
                                                        density: "compact",
                                                        "data-cy": "street"
                                                    }, null, 8, ["modelValue", "rules", "label"]),
                                                    _createVNode(_component_v_text_field, {
                                                        class: "v-col-3 compact",
                                                        modelValue: customer.unitNumber,
                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((customer.unitNumber) = $event)),
                                                        rules: [_unref(validationRules).required],
                                                        label: _unref(t)('checkout.unitNumber'),
                                                        density: "compact",
                                                        "data-cy": "unitNumber"
                                                    }, null, 8, ["modelValue", "rules", "label"]),
                                                    _createVNode(_component_v_text_field, {
                                                        class: "v-col-4 compact",
                                                        modelValue: customer.postcode,
                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((customer.postcode) = $event)),
                                                        rules: [_unref(validationRules).required],
                                                        label: _unref(t)('checkout.postcode'),
                                                        density: "compact",
                                                        "data-cy": "postcode"
                                                    }, null, 8, ["modelValue", "rules", "label"]),
                                                    _createVNode(_component_v_text_field, {
                                                        class: "v-col-8 compact",
                                                        modelValue: customer.city,
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((customer.city) = $event)),
                                                        rules: [_unref(validationRules).required],
                                                        label: _unref(t)('checkout.city'),
                                                        density: "compact",
                                                        "data-cy": "city"
                                                    }, null, 8, ["modelValue", "rules", "label"]),
                                                    _createVNode(_component_v_text_field, {
                                                        class: "v-col-6 compact",
                                                        modelValue: customer.mobile,
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((customer.mobile) = $event)),
                                                        rules: [_unref(validationRules).required],
                                                        label: _unref(t)('checkout.mobile'),
                                                        density: "compact",
                                                        "data-cy": "mobile"
                                                    }, null, 8, ["modelValue", "rules", "label"]),
                                                    _createVNode(_component_v_text_field, {
                                                        class: "v-col-6 compact",
                                                        modelValue: customer.phone,
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((customer.phone) = $event)),
                                                        rules: [],
                                                        label: _unref(t)('checkout.phone'),
                                                        density: "compact"
                                                    }, null, 8, ["modelValue", "label"]),
                                                    _createVNode(_component_v_text_field, {
                                                        class: "v-col-12 compact",
                                                        modelValue: customer.email,
                                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((customer.email) = $event)),
                                                        rules: [_unref(validationRules).required, _unref(validationRules).email],
                                                        label: _unref(t)('checkout.email'),
                                                        density: "compact",
                                                        "data-cy": "email"
                                                    }, null, 8, ["modelValue", "rules", "label"]),
                                                    _createVNode(_component_v_textarea, {
                                                        class: "v-col-12 compact pt-8",
                                                        label: _unref(t)('checkout.remarks'),
                                                        rules: [_unref(validationRules).maxLength(1000)],
                                                        "no-resize": "",
                                                        rows: "4",
                                                        modelValue: order.remarks,
                                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((order.remarks) = $event)),
                                                        density: "compact"
                                                    }, null, 8, ["label", "rules", "modelValue"]),
                                                    _createVNode(_component_v_container, { class: "d-flex justify-start text-h6 pa-2" }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_unref(t)('checkout.payment')), 1)
                                                        ]),
                                                        _: 1
                                                    }),
                                                    _createVNode(_component_v_divider),
                                                    _createVNode(_component_v_radio_group, {
                                                        class: "v-col-12",
                                                        modelValue: order.paymentMethod,
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((order.paymentMethod) = $event))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availablePaymentMethods.value, (paymentMethod) => {
                                                                return (_openBlock(), _createBlock(_component_v_radio, {
                                                                    key: paymentMethod,
                                                                    label: _unref(t)(paymentMethod),
                                                                    value: paymentMethod
                                                                }, null, 8, ["label", "value"]));
                                                            }), 128))
                                                        ]),
                                                        _: 1
                                                    }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_container, { class: "v-col-12 v-col-md-6 pl-md-4 pa-0" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_container, { class: "d-flex justify-start text-h6 pa-2" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(t)('checkout.yourOrder')), 1)
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_divider),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cartService).get_cart_items(), (cartItem, index) => {
                                                return (_openBlock(), _createBlock(CheckoutCartRow, {
                                                    key: index,
                                                    "cart-item": cartItem
                                                }, null, 8, ["cart-item"]));
                                            }), 128)),
                                            _createVNode(_component_v_divider),
                                            _createVNode(CartTotals, {
                                                totals: _unref(cartService).getCartTotals()
                                            }, null, 8, ["totals"]),
                                            _createVNode(_component_v_container, { class: "v-col-12 pa-0" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_checkbox, {
                                                        class: "pb-4",
                                                        modelValue: _unref(legalCheckbox),
                                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => (_isRef(legalCheckbox) ? (legalCheckbox).value = $event : legalCheckbox = $event)),
                                                        rules: [_unref(validationRules).required],
                                                        "data-cy": "legalCheckbox"
                                                    }, {
                                                        label: _withCtx(() => [
                                                            _createVNode(_component_i18n_t, {
                                                                keypath: "checkout.legalConsent",
                                                                tag: "div",
                                                                class: "v-container"
                                                            }, {
                                                                tac: _withCtx(() => [
                                                                    _createElementVNode("a", {
                                                                        href: _unref(settingsStore).settings.get('tac_link').value,
                                                                        target: "_blank",
                                                                        rel: "noopener noreferrer"
                                                                    }, _toDisplayString(_unref(t)('checkout.tac')), 9, _hoisted_1)
                                                                ]),
                                                                revocation: _withCtx(() => [
                                                                    _createElementVNode("a", {
                                                                        href: _unref(settingsStore).settings.get('revocation_link').value,
                                                                        target: "_blank",
                                                                        rel: "noopener noreferrer"
                                                                    }, _toDisplayString(_unref(t)('checkout.revocation')), 9, _hoisted_2)
                                                                ]),
                                                                dataProtection: _withCtx(() => [
                                                                    _createElementVNode("a", {
                                                                        href: _unref(settingsStore).settings.get('data_protection_link').value,
                                                                        target: "_blank",
                                                                        rel: "noopener noreferrer"
                                                                    }, _toDisplayString(_unref(t)('checkout.dataProtection')), 9, _hoisted_3)
                                                                ]),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    }, 8, ["modelValue", "rules"]),
                                                    _createVNode(_component_v_btn, {
                                                        "data-cy": "buyNow",
                                                        class: "v-col-12",
                                                        onClick: buyNow,
                                                        disabled: !canCheckout.value
                                                    }, {
                                                        default: _withCtx(() => [
                                                            (!_unref(orderInFlight))
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(t)('checkout.buyNow')), 1))
                                                                : _createCommentVNode("", true),
                                                            (_unref(orderInFlight))
                                                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                                                    key: 1,
                                                                    indeterminate: true
                                                                }))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _: 1
                                                    }, 8, ["disabled"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_dialog, {
                        modelValue: _unref(paymentFallbackDialog),
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => (_isRef(paymentFallbackDialog) ? (paymentFallbackDialog).value = $event : paymentFallbackDialog = $event)),
                        "max-width": "600px",
                        persistent: ""
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card, { "data-cy": "paymentFallbackDialog" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "text-h5 pa-4" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(t)('checkout.paymentFallback.title')), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_card_text, { class: "pa-4" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_alert, {
                                                type: "warning",
                                                variant: "tonal"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(t)('checkout.paymentFallback.text')), 1)
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_card_actions, { class: "pa-4" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_spacer),
                                            _createVNode(_component_v_btn, {
                                                "data-cy": "paymentFallbackProceed",
                                                color: "primary",
                                                variant: "flat",
                                                onClick: completeOrder
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(t)('checkout.paymentFallback.proceed')), 1)
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["modelValue"])
                ]),
                _: 1
            }, 512));
        };
    }
});
